const TRANSACTIONS_PATH = '/transactions'
const SSO_PATH = '/sso'
const USERS_PATH = '/users'
const REGISTER_PATH = '/register'
const RETAIL_PATH = '/retail'
const RECIPIENTS_PATH = '/recipients'

export { USERS_PATH, REGISTER_PATH, RETAIL_PATH, SSO_PATH, TRANSACTIONS_PATH, RECIPIENTS_PATH }
